import React, { useContext } from 'react';
import Icon from '../common/Icon';
import {
  handleSendTestMailer,
  relatedForms,
} from './constants/mailerConstants';
import { UserContext } from '../../hooks/Contexts';
import { useNavigate } from 'react-router-dom';
import {
  handleCopyMailer,
  handleDestroyMailer,
} from './constants/handleMailer';
import { sortByAlpha } from '../../helpers/sorters';

const MailerListItem = ({ mailer, setMailers }) => {
  const user = useContext(UserContext);
  const navigate = useNavigate();
  const hasRelatedForms = relatedForms(mailer).length > 0;
  const isInvalid = mailer?.scan_for_invalid_bodies?.body_is_invalid;

  const duplicateMailer = async () => {
    await handleCopyMailer(mailer.id, (response) => {
      if (response.ok)
        setMailers((mailers) =>
          sortByAlpha([...mailers, response.data], 'name')
        );
    });
  };

  const deleteMailer = async () => {
    await handleDestroyMailer(mailer.id, (response) => {
      if (response.ok) {
        setMailers((mailers) => {
          return mailers.filter((m) => m.id != mailer.id);
        });
      }
    });
  };

  return (
    <tr>
      {user.isAdmin ? (
        <td onClick={() => navigate(`/manage/mailers/${mailer.id}`)}>
          {mailer.name}
        </td>
      ) : (
        <td className='no-pointer'>{mailer.name}</td>
      )}
      <td className='no-pointer'>{mailer.on_submit ? 'Yes' : 'No'}</td>
      <td className='controls no-pointer'>
        {isInvalid && (
          <span className='warning-circle'>
            <i className='fa-solid fa-triangle-exclamation' />
          </span>
        )}
        {hasRelatedForms && (
          <i
            className='fa-solid fa-link'
            title='Mailer utilizes related forms'
          />
        )}

        <Icon
          className='test'
          title='Test mailer'
          onClick={() => handleSendTestMailer(mailer)}
          icon='mail-reply'
        />
        {user.isAdmin && (
          <>
            <Icon onClick={duplicateMailer} icon='copy' faPrefix={'regular'} />
            <Icon onClick={deleteMailer} icon='trash' />
          </>
        )}
      </td>
    </tr>
  );
};

export default MailerListItem;
